<template>
<li>
    <a href="/customers/"><i class="fa fa-user"></i> Customers
        <span class="badge badge-new-bookings" data-toggle="tooltip" data-placement="right" title="Customers text here">1</span>
    </a>
    <div class="grid-container3">
        <ul>
            <li><a href="/customers/"><i class="fa fa-user"></i> Übersicht</a></li>
            <li><a href="/customers/advanced/"><i class="fa fa-users"></i>Erweiterte Übersicht</a></li>
            <li>
                <a href="/customers/status/new/"><i class="fa fa-user-plus"></i> New customers &nbsp;
                    <span class="badge badge-new-bookings pull-right" data-toggle="tooltip" data-placement="right" title="New customers text here"></span>
                </a>
            </li>
            <li><a href="/customers/invoices/outstandings/"><i class="fa fa-folder-open-o"></i> Offene Posten</a></li>
            <li><a href="/customers/invoices/"><i class="fa fa-file-text-o"></i> Rechnungen</a></li>
            <li><a href="/customers/journal/"><i class="fa fa-book"></i> Journal</a></li>
            <li><a href="/customers/message/"><i class="fa fa-paper-plane-o"></i> Mitteilungen</a></li>
            <li>
                <a href="/customers/shoppingcarts/">
                    <i class="fa fa-shopping-cart"></i>Shopping cart
                    <span class="badge badge-new-bookings pull-right" data-toggle="tooltip" data-placement="right" title="New shopping carts text here">New shopping carts</span>
                </a>
            </li>
            <li><a href="/customers/topupcards/"><i class="fa fa-credit-card"></i> Topup cards</a></li>
        </ul>
    </div>
</li>
</template>

<script>
export default {
    //
}
</script>
